<div id="progress-bar-container" class="my-auto visible">
  <mat-progress-bar mode='indeterminate'></mat-progress-bar>
</div>
